import { render, staticRenderFns } from "./UpdateHubRestartSchedule.vue?vue&type=template&id=dd65220e"
import script from "./UpdateHubRestartSchedule.vue?vue&type=script&lang=js"
export * from "./UpdateHubRestartSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports